import React from "react";
import { toCsv, CsvColumn } from "./../../utils/csv";

type Props<T extends Record<string, any>> = {
  data: T[];
  filename?: string;
  columns?: CsvColumn<T>[];
  children?: React.ReactNode;
};

export function CsvDownloadButton<T extends Record<string, any>>({
  data,
  filename = "export.csv",
  columns,
  children,
}: Props<T>) {
  const handleDownload = React.useCallback(() => {
    const csvString = toCsv(data, columns);
    const bom = "\uFEFF";
    const blob = new Blob([bom + csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }, [data, filename, columns]);

  return (
    <button type="button" onClick={handleDownload}>
      {children ?? "Download CSV"}
    </button>
  );
}
